import { render, staticRenderFns } from "./CompositeChannelsTooltipDialog.vue?vue&type=template&id=0cd44556&scoped=true&"
import script from "./CompositeChannelsTooltipDialog.vue?vue&type=script&lang=js&"
export * from "./CompositeChannelsTooltipDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompositeChannelsTooltipDialog.vue?vue&type=style&index=0&id=0cd44556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd44556",
  null
  
)

export default component.exports